import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as"];
import React from 'react';
import PropTypes from 'prop-types';
/**
 * @type {React.FunctionComponent<{as: React.ComponentType}>}
 */

var Base = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var as = props.as,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var BaseInner = /*#__PURE__*/React.createElement(as, _extends({}, rest, {
    ref: ref
  }));
  return BaseInner;
});
Base.displayName = 'Base';
Base.identifier = Base.displayName;
Base.propTypes = {
  /** Render with a different HTML tag or a different custom component. */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node, PropTypes.object])
};
Base.defaultProps = {
  as: 'div'
};
export default Base;